define('Components/InstagramWidget/js/views/InstagramWidgetInstanceView',[
        'jquery',
        'app',
        'ProductBlockView',
        'underscore',
        'WidgetInstanceView',
        'template!Components/InstagramWidget/templates/default',
        'template!Components/InstagramWidget/templates/carousel',
        'Siema',
        'LazyLoad'
    ],
    function ($,
              app,
              ProductBlockView,
              _,
              WidgetInstanceView,
              defaultTemplate,
              carouselTemplate,
              Siema,
              LazyLoad) {

        return WidgetInstanceView.extend({
            name: 'InstagramWidgetInstanceView',
            getTemplate: function () {
                switch (this.model.getTemplate()) {
                    case 'carousel':
                        return carouselTemplate;
                    default:
                        return defaultTemplate;
                }
            },
            setup: function () {
                var view = this;
                view.privateSetup();
            },
            privateSetup:function(){
                // noop
            },
            onScroll: function () {
                var view = this;
                view.lazyLoad();
            },
            /**
             * Create new Siema slider
             * @param {string} selector         The selector to use as a carousel
             * @param {number|Object} perPage   The number of slides to be shown
             * @param {number} threshold        Touch and mouse dragging threshold (in px)
             * @param {number} duration         Slide transition duration in milliseconds
             * @param {boolean} loop            Loop the slides around
             * @returns {undefined}
             */
            addSlider: function (selector, perPage, threshold, duration, loop) {
                threshold = (typeof threshold !== 'undefined') ? threshold : 20;
                duration = (typeof duration !== 'undefined') ? duration : 200;
                loop = (typeof loop !== 'undefined') ? loop : false;
                var view = this, el = view.$(selector);
                console.log('siemaSlider',selector);

                if(!el.get(0)) return;

                try{
                var siemaSlider = new Siema({
                    selector: el.get(0),
                    duration: duration,
                    easing: 'ease-out',
                    perPage: perPage,
                    startIndex: 0,
                    draggable: true,
                    multipleDrag: true,
                    threshold: threshold,
                    loop: loop,
                    rtl: false,
                    //onInit: view.addMarginToProductBlocks,
                    //onChange: view.addMarginToProductBlocks
                });
                view.siemaSlider = siemaSlider;
                } catch (err) {
                    console.warn(err);
                }
            },
            lazyLoad: function () {
                var view = this;
                var lazyNotLoaded = view.$('img.lazyload:not(.ready)');
                LazyLoad(lazyNotLoaded);
            },
            addMarginToProductBlocks: function () {
                /*
                // PROBABLEMENT INUTILE
                var currentSlide = this.currentSlide,
                    winWidth = app.$window.width();
                if (winWidth <= _SCREEN_MEDIUM_) {
                    $(_DOT_ + _PRODUCT_BLOCK_).each(function (index) {
                        if (index === currentSlide) {
                            $(this).css('margin', '0 10px 0 0');
                        } else if (index === currentSlide + 1) {
                            if (index === $(_DOT_ + _PRODUCT_BLOCK_).length - 1) {
                                $(this).css('margin', '0 0 0 10px');
                            } else {
                                $(this).css('margin', '0 10px');
                            }
                        }
                    });
                }
                 */
            },
        })
    });
